import {FormGroup, FormControl, FormGroupDirective, NgForm, ValidatorFn} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material';

export class CustomValidators {

  public static passwordsMatch: ValidatorFn = (formGroup: FormGroup) => {

    // getting undefined values for both variables
    const password = formGroup.value.new_password;
    const confirmedPassword = formGroup.value.confirmed_password;
    // if I change this condition to === it throws the error if the
    //  two fields are the same, so this part works
    if (password !== confirmedPassword) {
      return {'passwordMismatch': true};
    } else {
      // it always gets here no matter what
      return null;
    }
  }
}

/**
 * Custom ErrorStateMatcher which returns true (error exists) when the parent form group is invalid and the control has been touched
*/
export class ConfirmValidParentMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return control.parent.invalid && (control.touched || isSubmitted );
  }
}

export const regExps: { [key: string]: RegExp } = {
  password: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/
};

/**
 * Collection of reusable error messages
 */
export const errorMessages: { [key: string]: string } = {
  password: 'Password can\'t be blank.',
  newPassword: 'Password must be between 7 and 15 characters, and contain at least one number and special character',
  confirmPassword: 'Passwords must match'
};



// WEBPACK FOOTER //
// ./src/app/profile/custom-validators.ts